import { Icon, Tooltip } from "@scuf/common";
import React from "react";
import "./RequestNewAlert.scss"

const RequestNewAlert = () => {

    return (<Tooltip className=''  content="Request new alert" element={<a title="Request new alert" className="fi-header__items__anytime-feedback alert-link" target="_blank" href="https://forms.office.com/r/MQbkL8mJeb"><Icon root="common" name="device-selected" size="medium" /></a>
}></Tooltip>)
}

export default RequestNewAlert;